import { Component, Input, Output, EventEmitter, forwardRef, HostListener } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

export interface DropdownOption {
	id: number;
	displayText: string;
	iconUrl?: string;
}

@Component({
	selector: 'app-icon-dropdown',
	templateUrl: './icon-dropdown.component.html',
	styleUrls: ['./icon-dropdown.component.scss'],
	providers: [
		{
			provide: NG_VALUE_ACCESSOR,
			useExisting: forwardRef(() => IconDropdownComponent),
			multi: true
		}
	]
})
export class IconDropdownComponent implements ControlValueAccessor {
	@Input() options: DropdownOption[] = [];
	@Input() placeholder: string = 'Select an option';
	@Output() selectionChange = new EventEmitter<number>();

	isDropdownOpen = false;
	selectedValue: number | null = null;

	private onChange: (value: any) => void = () => {};
	private onTouched: () => void = () => {};

	writeValue(value: number | null): void {
		this.selectedValue = value;
	}

	registerOnChange(fn: any): void {
		this.onChange = fn;
	}

	registerOnTouched(fn: any): void {
		this.onTouched = fn;
	}

	toggleDropdown(): void {
		this.isDropdownOpen = !this.isDropdownOpen;
		if (this.isDropdownOpen) {
			this.onTouched();
		}
	}

	selectOption(optionId: number): void {
		this.selectedValue = optionId;
		this.isDropdownOpen = false;
		this.onChange(optionId);
		this.selectionChange.emit(optionId);
	}

	getSelectedOption(): DropdownOption | null {
		return this.options.find(opt => opt.id === this.selectedValue) || null;
	}

	@HostListener('document:click', ['$event'])
	onDocumentClick(event: MouseEvent): void {
		const target = event.target as HTMLElement;
		const clickedInside = target.closest('.custom-select-wrapper');
		if (!clickedInside && this.isDropdownOpen) {
			this.isDropdownOpen = false;
		}
	}
}
